<template>
  <!-- Loader shown only at startup -->
  <Loader v-if="loading" />

  <!-- Main content shown after loading -->
  <div v-else>
    <Navbar />
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Loader from '@/components/Loader.vue';
import Navbar from '@/components/Navbar.vue';

// reactive loading state
const loading = ref(true);

// show loader only at initial website load
onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 1500); // Adjust duration as needed
});
</script>

<style>
/* Global app styling */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Add padding to main content for fixed navbar - Only when navbar is visible */
.main-content:not(:has(.login-container)) {
  padding-top: 80px;
}
/* Optional: hide scroll during loader */
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
</style>
